import { Component, OnInit, EventEmitter, Output ,Input, OnDestroy} from '@angular/core';
//import { ActivatedRoute } from '@angular/router';
import { PHBHPFeaturePackageUserManagementService} from '../ph-bhp-feature-package-user-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { UserData } from '../Models/UserData';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-viewuser',
  templateUrl: './ph-bhp-viewuser.component.html',
  styleUrls: ['./ph-bhp-viewuser.component.css']
})
export class PhBhpViewuserComponent implements OnInit,  OnDestroy {
  userSubscription: Subscription;
  addUserFormGeneralInfo: UntypedFormGroup;
  institutionChecked = {} as any;
  searchText:string;
  addUser: any = {};
  emitData: any = {
    key: "",
    val: ""
  }
  countryID = 0;
  emailExist : boolean = false;
  uNameExist : boolean = false;
  isMultiselect:boolean = true;
  Uservalue: any = {
    user: {},
    institutions: ""
  }
  institutionRadio;
  //@Input() userRole: string = 'Institution User';
  userData: any;
  userid: number;
  newUser;
  newRole;
  roleAndInstitutionsList: [any];
  institutionsList:any;
  itemChange: boolean = false;
  user: UserData;
  roleName: string;
  roleDetails = [
    {
      roleName: "Super Admin",
      roleId: 1
    },
    {
      roleName: "Country Admin",
      roleId: 2
    },
    {
      roleName: "Group Admin",
      roleId: 3
    },
    {
      roleName: "Institution Admin",
      roleId: 4
    },
    {
      roleName: "Institution User",
      roleId: 5
    }
  ]
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(
    private service: PHBHPFeaturePackageUserManagementService, 
    public layoutService: PHBHPLayoutPackageService,
    private router: Router,
    public config: AppConfig,
    private activatedRoute: ActivatedRoute
    ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(paramsId => {
      this.userid = paramsId.userid;
    });
    this.addUserFormGeneralInfo = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.compose([Validators.required])),
      email: new UntypedFormControl('', Validators.compose([Validators.required])),
      roleId: new UntypedFormControl('', Validators.compose([Validators.required])),
      isActive: new UntypedFormControl(true),
      username: new UntypedFormControl('', Validators.compose([Validators.required]))
    });
    
    if (this.userid) {
    this.service.getUserByUserId(this.userid).subscribe((res: any) => {
      this.newUser = res.user;
      switch (res.user.roleId) {
        case 1:
          this.roleName = this.roleDetails[0].roleName;
          break;
        case 2:
          this.roleName = this.roleDetails[1].roleName;
          break;
        case 3:
          this.roleName = this.roleDetails[2].roleName;
          break;
        case 4:
          this.roleName = this.roleDetails[3].roleName;
          break;
        case 5:
          this.roleName = this.roleDetails[4].roleName;
          break;
      }

      this.addUserFormGeneralInfo.setValue({
        name: res.user.name,
        email: res.user.email,
        roleId: res.user.roleId,
        isActive: res.user.isActive,
        username: res.user.username
      });
      this.user = res.user;
      var institutions = res.institutions.split(",");
      institutions.forEach(x => this.institutionChecked[x]  = true);
    })
  }

  if(this.config.userData) {
    this.userData = this.config.userData;
    this.onUserChanges();
  }

  this.userSubscription  = this.config.userSubject.asObservable().subscribe((changelang) => {
    this.userData = this.config.userData;
    this.onUserChanges();
  })
}

  onUserChanges() {
    if (this.userData && !this.itemChange) {
      this.itemChange = true;
      this.service.getUsersBountry(this.userid).subscribe((res: any) => {
        this.roleAndInstitutionsList = res;
        this.newRole = res.find(x=>x.role.roleId == this.addUserFormGeneralInfo.value.roleId);
        if(this.userid){
          this.onRoleChange(this.addUserFormGeneralInfo.value.roleId, false);
        }
      })
    }
  }
  
  ngOnDestroy(){
    if(this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  checkAll(ev) {
    this.countryID  = 0; 
    this.institutionsList.forEach((x, index)=> { 
      this.institutionChecked[x.institutionID] = ev.target.checked;
      if(index == 0 && ev.target.checked){
        this.countryID = x.countryID;
      }
    })
  }
 

  institutionString(){
    if(this.isMultiselect){
      return this.layoutService.objectString(this.institutionChecked);
    } else {
      return this.institutionRadio
    }  
  }

  onRoleChange(index: number, doFalse = true){
    var roleAndInstitutions;
    if(this.roleAndInstitutionsList){
      roleAndInstitutions =  this.roleAndInstitutionsList.find(roleAndInstitutions => roleAndInstitutions.role.roleId == index );
      if(roleAndInstitutions){
      this.institutionsList = roleAndInstitutions.institutions;
      this.isMultiselect = roleAndInstitutions.isMultiselect;
      }
    } 
    if(doFalse) {
      for (var key in this.institutionChecked) {
        this.institutionChecked[key] = false;
      }
    } if(!this.isMultiselect) {
      for (var key in this.institutionChecked) {
        this.institutionRadio = parseInt(key);
      }
    }
    
    
  }
  checkValue(institution){
    this.countryID= institution.countryID
  }
 
  
 

  onChildData(emitter : any){
    this.router.navigate([emitter.key]);
  }

  backToManageUser() {
    this.emitData = {};
    this.emitData.key = "user";
    //this.emitData.val=res.user;
    this.onChildData(this.emitData);
  }


 }
